import React, { useEffect, useState } from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";

import Select from "react-select";

import EditIcon from "../../../assets/icon/Edit.svg";
import {
  countryCodes,
  userProfileUpdate,
} from "../../../services/MainApiDetails";

import CloseIcon from "@mui/icons-material/Close";

import "./editModal.css";
import { ERROR } from "../../../utilities/colors";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditAddressModal = (prop) => {
  const [open, setOpen] = useState(false);
  const [countries, setCountries] = useState();
  const [selectedCountry, setSelectedCountry] = useState({
    value: "",
    label: "Please choose country",
  });
  const [address, setAddress] = useState("");
  const [errorAddress, setErrorAddress] = useState("");
  const [errorCountry, setErrorCountry] = useState("");
  const [errorPostalCode, setErrorPostalCode] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [state, setState] = useState("");

  const buttonDisabled = React.useMemo(
    () =>
      prop?.address?.trim() === address.trim() &&
      prop.state?.trim() === state?.trim() &&
      prop.postalCode?.trim() === postalCode?.trim() &&
      prop.country === selectedCountry.value,
    [
      prop.country,
      prop.state,
      prop.postalCode,
      prop.address,
      address,
      postalCode,
      state,
      selectedCountry.value,
    ],
  );

  console.log(prop?.address?.trim(), address.trim(),
  prop.state?.trim(),state?.trim(),
  prop.postalCode?.trim(), postalCode?.trim(),
  prop.country, selectedCountry.value,)

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getCountryCodes();
  }, []);

  React.useEffect(() => {
    setAddress(prop.address || "");
    setPostalCode(prop.postalCode || "");
    setState(prop.state || "");
    
      setSelectedCountry(!!prop.country ?  { value: prop.country, label: prop.country }:{
        value: "",
        label: "Please choose country",
      });

    if (open){
      setErrorAddress("")
      setErrorCountry("")
        setErrorPostalCode("")
      
    }
  }, [prop.country, prop.state, prop.postalCode, prop.address, open]);

  function getCountryCodes() {
    countryCodes({})
      .then((res) => {
        if (res.data.status === 1) {
          let countryDetails = res.data.result;
          settingCountry(countryDetails);
        }
      })
      .catch((err, message) => {
        console.log(err + message);
      });
  }

  function settingCountry(county_details) {
    let optionData = [];
    county_details.map((item) => {
      optionData.push({ value: item.name, label: item.name });
    });
    setCountries(optionData);
  }

  function createAddress() {
    if (!address) {
      setErrorAddress("Please enter Address");
    } else if (!postalCode) {
      setErrorPostalCode("Please enter postal code");
    } else if (!selectedCountry.value) {
      setErrorCountry("Please choose country");
    } else {
      userProfileUpdate({
        address: address?.trim(),
        zip_code: postalCode?.trim(),
        state: state?.trim(),
        country: selectedCountry.value?.trim(),
      })
        .then((res) => {
          if (res.data.status) {
            alert("Address updated successfully");
            setOpen(false);
            window.location.reload();
          } else {
            alert(res.data.message);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  function CountryNameSeting(e) {
    setSelectedCountry(e);
  }
  return (
    <div className="editAddressModal">
      <div onClick={handleClickOpen} className="userInfo-edit">
        <img src={EditIcon} alt="" />
      </div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="editNameModal-wrapper">
          <div className="editNameModal-closeIcon">
            <CloseIcon className="closeIcon" onClick={handleClose} />
          </div>
          <div className="editNameModal-header">
            <h2>{prop?.address ? "Edit":"Add"} Your Address</h2>
          </div>
          <div className="editNameModal-form-wrapper">
            <form action="">
              <div className="editNameModal-input-wrapper">
                <div className="editNameModal-inputBox">
                  <span>Address</span>
                  <textarea
                    value={address}
                    placeholder="Type here"
                    onChange={(e) => setAddress(e.target.value)}
                  ></textarea>
                  <span style={{ color: ERROR }}>{errorAddress}</span>
                </div>
                <div className="editNameModal-inputBox">
                  <span>Postal code</span>
                  <input
                    value={postalCode}
                    type="text"
                    placeholder="Type here"
                    onChange={(e) => setPostalCode(e.target.value)}
                  />
                  <span style={{ color: ERROR }}>{errorPostalCode}</span>
                </div>
                <div className="editNameModal-inputBox">
                  <span>State</span>
                  <input
                    value={state}
                    type="text"
                    onChange={(e) => setState(e.target.value)}
                    placeholder="Type here"
                  />
                </div>
                <div className="editNameModal-inputBox">
                  <span>Country</span>
                  <Select
                    value={selectedCountry}
                    onChange={(e) => CountryNameSeting(e)}
                    placeholder="Select your country"
                    options={countries}
                    menuPlacement="top"
                    className="select-option"
                  />
                  <span style={{ color: ERROR }}>{errorCountry}</span>
                </div>
              </div>
            </form>
          </div>
          <div className="editNameModal-button-wrapper">
            <Button
              type="button"
              disabled={buttonDisabled}
              onClick={() => createAddress()}
              className={
                buttonDisabled
                  ? "editNameModal-login-btn-disabled"
                  : "editNameModal-login-btn"
              }
            >
              {!!prop?.address ? "UPDATE" : "CONFIRM"}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default EditAddressModal;
